import React, { createContext, useContext, useState, useEffect } from 'react';

// v2 key: the old site saved 'light' for every visitor, which would override the new dark default.
const STORAGE_KEY = 'theme-v2';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check localStorage first, then default to dark mode
    try {
      const savedTheme = localStorage.getItem(STORAGE_KEY);
      if (savedTheme) {
        return savedTheme === 'dark';
      }
    } catch (error) {
      // Storage can be blocked (private mode); fall through to the default.
    }
    return true;
  });

  useEffect(() => {
    // Update document class and localStorage
    document.documentElement.classList.toggle('dark-mode', isDarkMode);
    try {
      localStorage.setItem(STORAGE_KEY, isDarkMode ? 'dark' : 'light');
    } catch (error) {
      // Theme still applies for this visit without storage.
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

